import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(advancedFormat);

@Pipe({
  name: 'moment',
  standalone: true,
})
export class MomentPipe implements PipeTransform {
  transform(value: any | null | undefined, ...args: any[]): string {
    if (value === undefined || value === null) return 'Not Available';

    return dayjs(this.getCreatedDate(value)).format(args[0]);
  }

  getCreatedDate(input: any): Date {
    // Firestore Timestamp
    if (typeof input.toDate === 'function') {
      return input.toDate();
    }

    // Already a Date object
    if (input instanceof Date) {
      return input;
    }

    if (typeof input === 'number') {
      const length = input.toString().length;

      // Unix seconds (10 digits)
      if (length === 10) {
        return dayjs.unix(input).toDate();
      }

      // Unix milliseconds (13 digits)
      if (length === 13) {
        return dayjs(input).toDate();
      }
    }

    // ISO string from ELK or other source
    return new Date(input);
  }
}
